export default __webpack_public_path__ + "static/media/vero.cbc23be9.png";